import { Component, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef, Input, Renderer2, ViewChild, ElementRef, Output, EventEmitter, OnInit, OnChanges, OnDestroy } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription } from "rxjs";

// Services
import { CoreLogService } from "../../services/log.service";
import { CoreCOMService } from "../../services/com.service";
import { CoreLanguageService } from "../../services/language.service";

// eigene Datenspeicher
import { CommunicationData } from "../../services/communicationdata.service";
// import { encodeUriQuery } from "@angular/router/src/url_tree"; todo i dont know why its not work

import { EnvDir } from "../../services/com/comEnvironmentFileSystem";

import { QRCode } from "../../forked/qr_code";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Globals } from "../../../globals";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { IOSHelperService } from "../../services/IOSHelper.service";

/**
* Anmeldung
*/
@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit, OnChanges, OnDestroy {
  public image_url: string = "";
  // Wir gehen davon aus, dass wir nicht über Input-Binding gebunden sind,
  // also nicht die Komponente in eine andere Komponente eingefügt wurde.
  private inputBinding: boolean = false;
  // Übergabeparameter
  private ParamsSubscriber: Subscription; // Subscriber zur Überwachung der Parameter, falls sich diese zur Laufzeit ändern.
  private _defaultHomeRoute: string = "/"; // Route für Home.
  @Input() private _backRoute: string;
  public backRoute: string = this._defaultHomeRoute; // Route für Zurück.
  public returnUrl: string;

  private LayoutClassSubscriber: Subscription;
  public layoutClass: string = "layout-colorful"; // Welches Layout soll angezeigt werden?
  private LanguageChoiceSubscriber: Subscription;
  private languageChoice: string = "en"; // Welche Sprache soll angezeigt werden?

  // Platzhalter, sind abhängig von der Sprache (LanguageChoice) und muss bei Änderung der Language geändert werden!
  public placeholderEMail: string = this._coreLanguageService.value("phLogin_PlaceholderEMail");
  public placeholderPassword: string = this._coreLanguageService.value("phLogin_PlaceholderPassword");
  private loginMessageErrorCode: string = "";
  private loginMessageErrorMessage: string = "";
  public loginMessage: string = "";

  private _userEMail: string = "";
  private _userPassword: string = "";

  public qrcodesvg: SafeHtml = "";

  @Output() closeModal = new EventEmitter(); // Event für das Schließen eines Modals.

  @ViewChild("messageBox") private _messageBox: ElementRef;

  constructor(private _router: Router,
    private _renderer: Renderer2,
    private _coreLanguageService: CoreLanguageService,
    private _communicationData: CommunicationData,
    private _activatedRoute: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreCOMService: CoreCOMService,
    private _coreLogService: CoreLogService,
    private _objObsInjectHelper: CircularInjectionHelper,
    private sanitized: DomSanitizer,
    private globals: Globals,
    private _iosHelperService: IOSHelperService) {

    _changeDetectorRef.detach();
  }

  /** Alle Änderungen der gebundenen Variablen an der Oberfläche neu darstellen. (Rerender) */
  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("LoginComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }


  public closeModalEvent() {
    // => Dann Modal schließen durch anzeigen von Event closeModal().
    // @Output() closeModal = new EventEmitter(); //Event für das Schließen eines Modals.
    this.closeModal.emit(null);
  }

  public StartSync() {
    const me = this;
  }

  public GetDeviceToken() {
    const me = this;
    me._objObsInjectHelper.yourAppServer.Api.GetDeviceToken().then(success => {
      me._coreLogService.debug("LoginComponent.GetDeviceToken", "NobodyLogin success=" + success);
      me._coreCOMService.environment.notification.info("NobodyLogin success", "success=" + success, true);
    }).catch(error => {
      me._coreLogService.error("LoginComponent.GetDeviceToken", "_yourAppServer.Auth.SignInNobody", error);
    });
  }

  public SignInNobody() {
    const me = this;
    me._objObsInjectHelper.yourAppServer.Auth.SignInNobody().then(success => {
      me._coreLogService.debug("LoginComponent.SignInNobodys", "NobodyLogin success=" + success);
      me._coreCOMService.environment.notification.info("NobodyLogin success", "success=" + success, true);
    }).catch(error => {
      me._coreLogService.error("LoginComponent.SignInNobody", "_yourAppServer.Auth.SignInNobody", error);
    });
  }

  public SignInAnonymous() {
    const me = this;
    me._objObsInjectHelper.yourAppServer.Auth.SignInAnonymous().then(success => {
      me._coreLogService.debug("LoginComponent.SignInAnonymous", "AnonymousLogin success=" + success);
      me._coreCOMService.environment.notification.info("AnonymousLogin success", "success=" + success, true);
    }).catch(error => {
      me._coreLogService.error("LoginComponent.SignInAnonymous", "_yourAppServer.Auth.SignInAnonymous", error);
    });
  }

  public TestAuthFunction() {
    // this._yourAppServer.Api.RequestService(CountrySyncViewModel, "test/UserInfo", { "filter": true, "id": 22, "name": "none" })
    // .catch(error => { console.log(error); });
    //   .then((val) => { console.log("response:"); console.log(val); console.log(val.Data); })
  }

  public Login() {
    // console.log("***************** Login")

    // Login mit den Daten versuchen.
    const me = this;
  }

  public changeEMail(_userEMail: string) {
    // Meldung deaktivieren.
    this._renderer.setStyle(this._messageBox.nativeElement, "display", "none");
    this._userEMail = _userEMail;

    // Alle Änderungen darstellen.
    this.PushChanges();
  }

  public changePassword(_userPassword: string) {
    // Meldung deaktivieren.
    this._renderer.setStyle(this._messageBox.nativeElement, "display", "none");
    this._userPassword = _userPassword;

    // Alle Änderungen darstellen.
    this.PushChanges();
  }

  public ngOnChanges(changes: SimpleChanges) {
    // Respond when Angular (re)sets data-bound input properties. The method receives a SimpleChanges object of current and previous property values.
    // Called before ngOnInit() and whenever one or more data- bound input properties change.

    // ngOnChanges wird nur aufgerufen, wenn auch wirklich etwas an die @Input-Properties übergeben wird.
    // => Dann kann der Aufruf aber nicht über einen routerLink oder die direkte Eingabe der URL sein.
    // => Dann müssen wir uns nicht über die Überwachung der @Input-Properties kümmern,
    //    dazu wird automatisch ngOnChanges von angular 2 aufgerufen.
    // => Wenn die @Input-Property nicht gesetzt ist, dann sollte hier der Standardwert gesetzt werden.
    if (this._backRoute != null) {
      this.backRoute = this._backRoute;
      this.inputBinding = true;
    } else {
      this.backRoute = this._defaultHomeRoute; // Standardwert auf Home
    }
    // => ngOnChanges darf nie asynchron ausgeführt werden, damit der Wert von inputBinding richtig gesetzt ist
    //    bevor ngOnInit ausgeführt wird!
    // Mit dem Setzen von inputBinding wird Komponente für die gesamte Lebenszeit signalisiert, dass diese
    // Komponente in eine andere Komponente eingefügt wurde.
  }

  public ngOnInit(): void {
    // Initialize the directive/component after Angular first displays the data-bound properties and sets the directive/component"s input properties.
    // Called once, after the first ngOnChanges().
    this.qrcodesvg = this.sanitized.bypassSecurityTrustHtml(new QRCode("HYAR=143").svg_in_spinner({ width: 150, border: 15 }));

    // set Return Url when redirect to login from other pages such as coupon.
    // returnUrl used to redirect back to coupon page(it can used for every page that needs login )
    this.returnUrl = this._activatedRoute.snapshot.queryParams["returnUrl"] || "/";

    // Wurde diese Komponente NICHT in eine andere Komponente eingefügt?
    if (!this.inputBinding) {
      // Nur dann können die Parameter auch über die über einen routerLink oder die direkte Eingabe der URL
      // übergeben worden sein.
      // Die Parameter dann überwachen, da sich die Parameter auch zur Laufzeit ändern können.
      this.ParamsSubscriber = this._activatedRoute.params.subscribe((params: Params) => {
        if (params["_backRoute"] != null) {
          this.backRoute = params["_backRoute"];
        } else {
          this.backRoute = this._defaultHomeRoute; // Standardwert auf Home
        }

        // Alle Änderungen darstellen.
        this.PushChanges();
      });
    }

    // Überwachen, ob sich die Auswahl für das Layout geändert hat.
    this.LayoutClassSubscriber = this._communicationData.LayoutClass().subscribe((layoutClass: string) => {
      if (this.layoutClass !== layoutClass) {
        this.layoutClass = layoutClass;

        // Alle Änderungen darstellen.
        this.PushChanges();
      }
    });

    // Übergebene dynamische Sprachkeys abfragen.
    // Dynamische Sprachkeys abfragen.
    this.placeholderEMail = this._coreLanguageService.value("phLogin_PlaceholderEMail");
    this.placeholderPassword = this._coreLanguageService.value("phLogin_PlaceholderPassword");
    // Überwachen, ob sich die Auswahl für die Sprache geändert hat.
    this.LanguageChoiceSubscriber = this._communicationData.LanguageChoice().subscribe((languageChoice: string) => {
      if (this.languageChoice !== languageChoice) {
        this.languageChoice = languageChoice;
        // Übergebene dynamische Sprachkeys abfragen.
        // Dynamische Sprachkeys abfragen.
        this.placeholderEMail = this._coreLanguageService.value("phLogin_PlaceholderEMail");
        this.placeholderPassword = this._coreLanguageService.value("phLogin_PlaceholderPassword");
        // Richtige Fehlermeldung ein- oder ausblenden.
        if (this.loginMessageErrorCode === "") {
          this._renderer.setStyle(this._messageBox.nativeElement, "display", "none");
        } else {
          switch (this.loginMessageErrorCode) {
            case "login/unknown-reason": {
              this.loginMessage = this._coreLanguageService.value("phLogin_Message") + "<br />" + this._coreLanguageService.value("phLogin_MessageErrorLogin_UnknownReason");
              break;
            }
            case "login/no-email-given": {
              this.loginMessage = this._coreLanguageService.value("phLogin_Message") + "<br />" + this._coreLanguageService.value("phLogin_MessageErrorLogin_NoEmailGiven");
              break;
            }
            case "login/no-password-given": {
              this.loginMessage = this._coreLanguageService.value("phLogin_Message") + "<br />" + this._coreLanguageService.value("phLogin_MessageErrorLogin_NoPasswordGiven");
              break;
            }
            case "auth/invalid-email": {
              this.loginMessage = this._coreLanguageService.value("phLogin_Message") + "<br />" + this._coreLanguageService.value("phLogin_MessageErrorAuth_InvalidEmail");
              break;
            }
            case "auth/user-disabled": {
              this.loginMessage = this._coreLanguageService.value("phLogin_Message") + "<br />" + this._coreLanguageService.value("phLogin_MessageErrorAuth_UserDisabled");
              break;
            }
            case "auth/user-not-found": {
              this.loginMessage = this._coreLanguageService.value("phLogin_Message") + "<br />" + this._coreLanguageService.value("phLogin_MessageErrorAuth_UserNotFound");
              break;
            }
            case "auth/wrong-password": {
              this.loginMessage = this._coreLanguageService.value("phLogin_Message") + "<br />" + this._coreLanguageService.value("phLogin_MessageErrorAuth_WrongPassword");
              break;
            }
            case "login/PasswordResetEmailSend": {
              this.loginMessage = this._coreLanguageService.value("phLogin_PasswordResetEmailSend").replace("<email>", this._userEMail);
              break;
            }
            default: {
              this.loginMessage = this._coreLanguageService.value("phLogin_Message") + "<br />" + this.loginMessageErrorMessage + " (" + this.loginMessageErrorCode + ")";
              break;
            }
          }
          this._renderer.setStyle(this._messageBox.nativeElement, "display", "flex");
        }

        this.PushChanges();
      }
    });

    this.PushChanges();
  }

  public ngOnDestroy(): void {
    const me = this;
    // Cleanup just before Angular destroys the directive/component. Unsubscribe Observables and detach event handlers to avoid memory leaks.
    // Called just before Angular destroys the directive/component.
    if (me.LanguageChoiceSubscriber) {
      me.LanguageChoiceSubscriber.unsubscribe();
    }
    if (me.LayoutClassSubscriber) {
      me.LayoutClassSubscriber.unsubscribe();
    }
    // Wurde diese Komponente NICHT in eine andere Komponente eingefügt?
    if (!me.inputBinding) {
      // Dann die Überwachung der Parameter beenden, wenn die Komponente aus dem Speicher entfernt wird.
      if (me.ParamsSubscriber) {
        me.ParamsSubscriber.unsubscribe();
      }
    }
  }

  public TestChangedata() {
    const me = this;
    // me._objectObserverService.GetObject()
    //   .then((model) => {
    //     this._coreLogService.debug("LoginComponent.TestChangedata", "_changeDetectorRef.detectChanges (model)", model);
    //   })
    //   .catch((error) => {
    //     this._coreLogService.error("LoginComponent.TestChangedata", "_objectObserverService.GetObject (catch)", error);
    // });
    // let RequestData = new CountrySyncModel();
    // RequestData.changes_since_ymd = 20010101;
    // RequestData.changes_since_hms = 1;
    //
    // this._yourAppServer.Api.RequestService(CountrySyncViewModel, "location/GetNewCountries", RequestData)
    //   .then((val) => { console.log("response:"); console.log(val); console.log(val.Data); })
    //   .catch(error => { console.log(error); });
    //
    //   RequestData = new LocationSyncModel();
    //   RequestData.changes_since_ymd = 20010101;
    //   RequestData.changes_since_hms = 1;
    // this._yourAppServer.Api.RequestService(LocationSyncViewModel, "location/GetNewLocations2", RequestData)
    // .then((val) => { console.log("response:"); console.log(val); console.log(val.Data); })
    // .catch(error => { console.log(error); });
  }

  public TestRefresh() {
    this.PushChanges();
    this._objObsInjectHelper.yourAppServer.Auth.RefreshToken();
  }

  public TestDownload() {
    const me = this;

    function download(fileEntry, uri, readBinaryData) {

      const fileTransfer = new FileTransfer();
      const fileURL = fileEntry.toURL();

      fileTransfer.onprogress = function (progressEvent) {
        if (progressEvent.lengthComputable) {
          const percentage = Math.floor(progressEvent.loaded / progressEvent.total * 100);
          me._coreCOMService.environment.notification.info("TestDownload progress", percentage.toString() + "%", true);
          // document.dispatchEvent(createEvent("DOWNLOADER_downloadProgress", [percentage, fileObject.name]));
        }
      };

      fileTransfer.download(
        uri,
        fileURL,
        function (entry) {
          me._coreCOMService.environment.notification.info("Successful download..", "download complete: " + entry.toURL(), true);
          me.image_url = entry.toURL();
          me.PushChanges();
          if (readBinaryData) {
            // Read the file...
            // readBinaryFile(entry);
          } else {
            // Or just display it.
            // displayImageByFileURL(entry);
          }
        },
        function (error) {
          this._coreLogService.error("LoginComponent.TestDownload", "fileTransfer.download", error);
        },
        null, // or, pass false
        {
          // headers: {
          //     "Authorization": "Basic dGVzdHVzZXJuYW1lOnRlc3RwYXNzd29yZA=="
          // }
        }
      );
    }

    const transferFile = function (fileObject) {
      // console.log("tranfserFile");
      const filePath = cordova.file.dataDirectory + fileObject.name;
      const transfer = new FileTransfer();
      transfer.onprogress = function (progressEvent) {
        if (progressEvent.lengthComputable) {
          const percentage = Math.floor(progressEvent.loaded / progressEvent.total * 100);
          me._coreCOMService.environment.notification.info("TestDownload progress", percentage.toString() + "%", true);
          // document.dispatchEvent(createEvent("DOWNLOADER_downloadProgress", [percentage, fileObject.name]));
        }
      };
      transfer.download(fileObject.url, filePath, function (entry) {
        // console.log("transferFile, succcess file name: " + Downloader.fileObjectInProgress.name);
        me._coreCOMService.environment.notification.info("TestDownload success", entry.fullPath, true);
        // document.dispatchEvent(createEvent("DOWNLOADER_downloadSuccess", [entry]));
      }, function (error) {
        // console.log("transferFile, error file name: " + Downloader.fileObjectInProgress.name);
        me._coreCOMService.environment.notification.info("TestDownload fail", error.code.toString(), true);
        // document.dispatchEvent(createEvent("DOWNLOADER_downloadError", [error]));
      });
    };
    const url = encodeURI("https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/FuBK_testcard_vectorized.svg/1024px-FuBK_testcard_vectorized.svg.png");
    const name = null;
    const md5 = null;
    const fileObject = {
      url: url,
      name: name || url.replace(/^.*\//, ""),
      md5: md5
    };
    me._coreCOMService.environment.fileSystem.createFile(EnvDir.Data, "test", fileObject.name)
      .then((fileEntry) => {
        download(fileEntry, fileObject.url, true);
      })
      .catch((error) => {
        me._coreCOMService.environment.notification.info("TestDownload fail", "debug", true);
      });
    // transferFile(fileObject);
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  public TestLoginForReturnUrl() {
    this.globals.isLogin = true;
    this._router.navigateByUrl(this.returnUrl);
  }

}
